// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e9c7a08","453":"0d40c083","455":"cec148d0","977":"b76a6622"}[chunkId] + ".chunk.js";
};